$(document).ready(function(){
                  // homepage image with text slider
  $('.cust_image_sec .cust_home_best_seller_all').slick({
  dots: false,
   arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  // variableWidth: true,
  slidesToScroll: 1,
  adaptiveHeight: true,
    centerMode: true,
  centerPadding: '20px',
  touchThreshold: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 4,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  
  $(document).on("click", ".cust_image_sec .header button.arrow_next", function(){
    $(this).parents(".cust_home_best_seller").find(".cust_home_best_seller_all button.slick-next.slick-arrow").trigger('click');    
  })
  $(document).on("click", ".cust_image_sec .header button.arrow_prev", function(){
    $(this).parents(".cust_home_best_seller").find(".cust_home_best_seller_all button.slick-prev.slick-arrow").trigger('click');    
  })

//   setTimeout(function(){
//    $('.cust_related product-recommendations product-list.product-list').slick({
//   dots: false,
//  arrows: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 5,
//   // variableWidth: true,
//   slidesToScroll: 1,
//   adaptiveHeight: true,
//     centerMode: true,
//   centerPadding: '20px',
//   touchThreshold: 5000,
//   responsive: [
//     {
//       breakpoint: 1450,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         centerMode: true,
//   centerPadding: '20px',
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         centerMode: true,
//   centerPadding: '20px',
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         centerMode: true,
//   centerPadding: '20px',
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
// },2500)
  let intervalId = setInterval(function() {
var rec_list = $(".cust_related product-recommendations product-list.product-list product-card.product-card").length;
    if(rec_list > 5){
      $(".cust_related").addClass("show_arrow")
  $(".cust_related product-recommendations product-list.product-list").slick({
      dots: false,
 arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  // variableWidth: true,
  slidesToScroll: 1,
  adaptiveHeight: true,
    // centerMode: true,
  // centerPadding: '20px',
  touchThreshold: 5000,
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]    
  });
    clearInterval(intervalId);
  }  
  },1000);
  
  $('.home_best_seller reveal-items product-list.product-list').slick({
  dots: false,
 arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  // variableWidth: true,
  slidesToScroll: 1,
  adaptiveHeight: true,
    centerMode: true,
  centerPadding: '20px',
  touchThreshold: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: true,
  centerPadding: '20px',
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
   

  $(document).on("click", ".home_best_seller .cust_arrow button#next_btn", function(){
    $(this).parents(".home_best_seller").find("reveal-items product-list.product-list button.slick-next.slick-arrow").trigger('click');
    // $(".home_best_seller reveal-items product-list.product-list button.slick-next.slick-arrow").trigger('click');
  })
  $(document).on("click", ".home_best_seller .cust_arrow button#prev_btn", function(){        
    $(this).parents(".home_best_seller").find("reveal-items product-list.product-list button.slick-prev.slick-arrow").trigger('click');
    //$(".home_best_seller reveal-items product-list.product-list button.slick-prev.slick-arrow").trigger('click');
  })

   $('.top-arrow .up_slide.slider-fors').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.double_sliders .slider-navs',
     responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows:false            
          }
        }
      ]
});
$('.double_sliders .slider-navs').slick({
  autoplay:true,
  arrows: false,
  // slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.top-arrow .up_slide.slider-fors',
  dots: false,  
  infinite: true,
   centerMode: true,
  variableWidth: true,
  focusOnSelect: true,
  responsive: [
        {
          breakpoint: 1024,
          settings: {
            // slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows:false,
            variableWidth: false,
            slidesToShow:3,
            slidesToScroll: 1,
            centerPadding:'0px'
            //autoplay: true
          }
        }
      ]
});

jQuery(window).on('load resize', function (event) { 
	let myMediaQuery = window.matchMedia('(max-width: 767px)');
      if(myMediaQuery.matches) {
          $('.text_scroll_sec .text_scroll_content'). slick({
            dots: true,
            arrows:false,
            infinite: true,
            mobileFirst: true,
            arrows:false,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchThreshold: 5000,
            // variableWidth: true,
          });       
      	}

}).resize();

        $('.vertical-slider ul li').on('click', function() {
    $(this).parents("ul").find("li").removeClass("activex");
    $(this).addClass("activex");
   var aa = $(this).attr("data-attr");
   let myMediaQuery = window.matchMedia('(min-width: 1025px)');
      if(myMediaQuery.matches) {
      $(this).parents(".vertical-slider").find(".vertical-second").hide();
      $(this).parents(".vertical-slider").find(".vertical-second[data-var='"+aa+"']").show();
      }
   
});
    $(document).on("click", ".cust_prod_sec .accordion-item>button", function(){
      if($(this).attr('aria-expanded') === "false"){
          $(this).attr('aria-expanded', 'true')
      }else{
          $(this).attr('aria-expanded', 'false')
      }    
  })

  // size guide pop up open close 
  $(document).on("click",".cust_size_guide", function(){
        $("#popup_2").show();
    $("body").addClass("open_size_guid_popUP");
      $("#popup_2 .popup-content").addClass("scaleIn");
    });
  $(document).on("click","#popup_2 a.close-popup", function(e){
        e.preventDefault();
    $("#popup_2 .popup-content").removeClass("scaleIn");        
          $("#popup_2 .popup-content").addClass("scaleOut");
    setTimeout(function(){
        $("#popup_2").hide();
        $("body").removeClass("open_size_guid_popUP");        
        $("#popup_2 .popup-content").removeClass("scaleOut");
    },200)
    
    });

  // go to all reviews

    $(document).on('click', '.dynamic_rev', function(event) { 
       event.preventDefault();      
       $('html, body').animate({
         scrollTop: $($('article.jdgm-widget')).offset().top - 150
       }, 1000);
      });
  
  
}) // end document ready